import { truncateLongText } from "utilities/utilities";
import { useStyles } from "./ActionPlanDescriptionCell.styles";
import { IActionPlanDescriptionCell } from "./ActionPlanDescriptionCellInterfaces";
import { useCharFit } from "hooks/useCharFit";

const ActionPlanDescriptionCell = ({ actionPlan }: IActionPlanDescriptionCell) => {
    const classes = useStyles();
    const { cellRef, charsThatCanFit } = useCharFit();

    return (
        <div ref={cellRef} className={classes.descriptionWrapper}>
            <span className={classes.text}>{truncateLongText(actionPlan.name, charsThatCanFit)}</span>
        </div>
    );
};

export default ActionPlanDescriptionCell;
